import { AxiosInstance } from 'axios';
import { HotelService } from 'services/Settings';
import { ApplogServiceModel, initApplogService } from './Services/ApplogService';
import {
  CashierRootServiceModel,
  initCashierRootService,
} from './Services/CashierService/RootCashier';
import { DashboardServiceModel, initDashboardService } from './Services/DashboardService';
import { DraftServiceModel, initDraftService } from './Services/DraftService';
import { EndOfDayServiceModel, initEndOfDayService } from './Services/EndOfDayServices';
import {
  FinancialServiceServiceModel,
  initFinancialServiceService,
} from './Services/FinancialService';
import {
  GlobalSettingsServiceModel,
  initGlobalSettingsService,
} from './Services/GlobalSettingsServices';
import { HotelSettingServiceModel, initHotelSettingService } from './Services/HotelSettingServices';
import {
  HotelRevenueManagementServiceModel,
  initHotelRevenueManagementService,
} from './Services/HotelSettingServices/RevenueManagement';
import { HouseKeepingServiceModel, initHouseKeepingService } from './Services/HouseKeepingService';
import { ReportServiceType, initReportService } from './Services/Report';
import { ReservationsService, initReservationsService } from './Services/ReservationsServices';
import { SharedServiceModel, initSharedService } from './Services/Shared';
import { WidgetsServiceModel, initWidgetsService } from './Services/WidgetsServices';

export interface SettingInfosServiceModel {
  getInfos: ReturnType<typeof HotelService.getInfos>;
  update: ReturnType<typeof HotelService.update>;
}

export interface HotelServiceModel {
  hotel: SettingInfosServiceModel;
  settings: HotelSettingServiceModel;
  revenueManagement: HotelRevenueManagementServiceModel;
  reservations: ReservationsService;
  widgets: WidgetsServiceModel;
  globalSettings: GlobalSettingsServiceModel;
  dashboard: DashboardServiceModel;
  draft: DraftServiceModel;
  endOfDay: EndOfDayServiceModel;
  houseKeeping: HouseKeepingServiceModel;
  cashier: CashierRootServiceModel;
  financial: FinancialServiceServiceModel;
  report: ReportServiceType;
  applog: ApplogServiceModel;
  shared: SharedServiceModel;
}

export const getHotelService = (axios: AxiosInstance): HotelServiceModel => ({
  hotel: {
    getInfos: HotelService.getInfos(axios),
    update: HotelService.update(axios),
  },
  revenueManagement: initHotelRevenueManagementService(axios),
  settings: initHotelSettingService(axios),
  reservations: initReservationsService(axios),
  widgets: initWidgetsService(axios),
  globalSettings: initGlobalSettingsService(axios),
  dashboard: initDashboardService(axios),
  draft: initDraftService(axios),
  endOfDay: initEndOfDayService(axios),
  houseKeeping: initHouseKeepingService(axios),
  cashier: initCashierRootService(axios),
  financial: initFinancialServiceService(axios),
  report: initReportService(axios),
  applog: initApplogService(axios),
  shared: initSharedService(axios),
});
